export enum ElaasFormulaCode {
  GI_TOX = 'GI_TOX',
  MARSDEN_WEIGHT_SCALE = 'MARSDEN_WEIGHT_SCALE',
  MASIMO_SPO2 = 'MASIMO_SPO2',
  MIR_PEF = 'MIR_PEF',
  COMPARE_OCCURRENCES_WITH_THRESHOLD = 'COMPARE_OCCURRENCES_WITH_THRESHOLD',
  COMPARE_OCCURRENCES_COUNT_WITH_THRESHOLD = 'COMPARE_OCCURRENCES_COUNT_WITH_THRESHOLD',
  COMPARE_NUMERIC_WITH_THRESHOLD = 'COMPARE_NUMERIC_WITH_THRESHOLD',
  COMPARE_WITH_PREVIOUS_NUMERIC = 'COMPARE_WITH_PREVIOUS_NUMERIC',
  CAPTURE_TREND_RELATIVE_TO_BASELINE = 'CAPTURE_TREND_RELATIVE_TO_BASELINE',
  IS_ANSWER_SELECTED = 'IS_ANSWER_SELECTED',
  WEIGHT_CHANGE = 'WEIGHT_CHANGE',
  COMPARE_WITH_PREVIOUS_NUMERICS_INCREASED = 'COMPARE_WITH_PREVIOUS_NUMERICS_INCREASED',
  COMPARE_REPEAT_INDEX_WITH_THRESHOLD = 'COMPARE_REPEAT_INDEX_WITH_THRESHOLD',
  GI_COMPARE_WITH_PREVIOUS_NUMERICS_INCREASED = 'GI_COMPARE_WITH_PREVIOUS_NUMERICS_INCREASED',
}
